<template>
  <section id="fqa" class="faq-servicios">
    <!-- Header con logo y título -->
    <div class="faq-header">
      <img src="@/assets/logo_sin_fondo_recortado.png" alt="Logo Empresa" class="faq-logo" />
      <h2 class="faq-titulo">💡 Nuestros Servicios</h2>
    </div>

    <!-- Lista FAQ -->
    <div class="faq-lista">
      <div
        v-for="(item, index) in servicios"
        :key="index"
        class="faq-item"
        :class="{ abierto: item.abierto }"
        :style="{ animationDelay: (index * 0.2) + 's' }"
      >
        <div class="faq-pregunta" @click="toggle(index)">
          <span>{{ item.titulo }}</span>
          <svg
            class="faq-icono"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 9l-7 7-7-7" />
          </svg>
        </div>
        <transition name="desplegar">
          <div v-if="item.abierto" class="faq-respuesta">
            <p>{{ item.descripcion }}</p>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServiciosFAQ",
 data() {
  return {
    servicios: [
      {
        titulo: "💻 Diagnóstico de Sistemas",
        descripcion:
          "Evaluación completa de hardware y software para detectar problemas y optimizar el rendimiento de tus equipos.",
        abierto: false,
      },
      {
        titulo: "🛠️ Mantenimiento Preventivo",
        descripcion:
          "Limpieza interna de equipos, actualización de drivers, optimización del sistema y prolongación de la vida útil de tus dispositivos.",
        abierto: false,
      },
      {
        titulo: "🔄 Actualización y Optimización",
        descripcion:
          "Actualización de sistemas operativos, software y aplicaciones para mejorar el desempeño y seguridad de tus equipos.",
        abierto: false,
      },
      {
        titulo: "💾 Respaldo de Información",
        descripcion:
          "Creación de copias de seguridad de archivos importantes en la nube o dispositivos externos para evitar pérdida de datos.",
        abierto: false,
      },
      {
        titulo: "📂 Recuperación de Información",
        descripcion:
          "Recuperación de datos perdidos en discos duros, memorias USB, tarjetas SD y otros dispositivos de almacenamiento.",
        abierto: false,
      },
      {
        titulo: "🖥️ Instalación de Sistemas Operativos",
        descripcion:
          "Instalación de Windows, Linux, macOS y configuración completa para un arranque estable y seguro.",
        abierto: false,
      },
      {
        titulo: "📊 Sistemas Administrativos",
        descripcion:
          "Implementación y soporte de software administrativo, contable o ERP para empresas de cualquier tamaño.",
        abierto: false,
      },
      {
        titulo: "🗑️ Formateo Profesional",
        descripcion:
          "Formateo completo de computadoras y laptops, eliminando virus y optimizando el rendimiento del sistema.",
        abierto: false,
      },
      {
        titulo: "🛒 Venta de Equipos y Consumibles",
        descripcion:
          "Equipos nuevos y reacondicionados, accesorios, consumibles, repuestos originales y periféricos de alta calidad.",
        abierto: false,
      },
      {
        titulo: "🌐 Configuración de Redes y Seguridad",
        descripcion:
          "Instalación y configuración de redes Wi-Fi, routers, servidores y sistemas de seguridad informática para empresas y hogar.",
        abierto: false,
      },
      {
        titulo: "💡 Asesoría Tecnológica",
        descripcion:
          "Recomendaciones personalizadas para mejorar la infraestructura tecnológica de tu empresa o equipo personal.",
        abierto: false,
      },
      {
        titulo: "🖱️ Soporte Remoto",
        descripcion:
          "Asistencia técnica a distancia para resolver problemas de software, configuración de programas y optimización del sistema.",
        abierto: false,
      },
      {
        titulo: "🛡️ Seguridad Informática Avanzada",
        descripcion:
          "Protección contra malware, ransomware y ataques cibernéticos; instalación de antivirus y firewalls.",
        abierto: false,
      },
      {
        titulo: "⚙️ Instalación de Software Especializado",
        descripcion:
          "Implementación de programas de diseño, edición, desarrollo y herramientas profesionales según tus necesidades.",
        abierto: false,
      },
    ],
  };
},
  methods: {
    toggle(index) {
      this.servicios[index].abierto = !this.servicios[index].abierto;
    },
  },
};
</script>



<style scoped>
.faq-servicios {
  background: url('@/assets/Img/Banners/computacion.jpg') no-repeat center center;
  background-size: cover;
  padding: 3rem 2rem;
  position: relative;
  color: #fff;
}

.faq-servicios::before {
  content: "";
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.7);
  z-index: 0;
}

.faq-servicios > * {
  position: relative;
  z-index: 1;
}

/* Header con logo y título */
.faq-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.2rem;
  margin-bottom: 2rem;
  animation: fadeInDown 1s ease-in-out;
}

.faq-logo {
  width: 70px;
  height: auto;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(0, 242, 255, 0.4);
  animation: pulse 2s infinite;
}

.faq-titulo {
  font-size: 2.4rem;
  font-weight: bold;
  color: #00f2ff;
  text-shadow: 0 2px 6px rgba(0, 242, 255, 0.8);
  text-align: center;
}

/* FAQ lista */
.faq-lista {
  max-width: 850px;
  margin: 0 auto;
  text-align: left;
}

.faq-item {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 14px;
  margin-bottom: 1rem;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  opacity: 0;
  transform: translateY(40px);
  animation: fadeInUp 0.8s forwards;
}

.faq-item.abierto {
  border: 1px solid #00f2ff;
  box-shadow: 0 6px 20px rgba(0, 242, 255, 0.4);
}

.faq-pregunta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.2rem;
  cursor: pointer;
  font-weight: bold;
  font-size: 1.2rem;
  transition: background 0.3s ease;
}

.faq-pregunta:hover {
  background: rgba(0, 242, 255, 0.1);
}

.faq-icono {
  width: 26px;
  height: 26px;
  transition: transform 0.4s ease;
}

.faq-item.abierto .faq-icono {
  transform: rotate(180deg) scale(1.2);
  color: #00f2ff;
}

.faq-respuesta {
  padding: 1rem 1.2rem;
  font-size: 1rem;
  line-height: 1.6;
  color: #ddd;
  animation: fadeIn 0.4s ease;
}

/* Animaciones */
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(40px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-40px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes pulse {
  0% { transform: scale(1); box-shadow: 0 0 10px rgba(0,242,255,0.6); }
  50% { transform: scale(1.05); box-shadow: 0 0 20px rgba(0,242,255,0.9); }
  100% { transform: scale(1); box-shadow: 0 0 10px rgba(0,242,255,0.6); }
}

/* Transición desplegable */
.desplegar-enter-active,
.desplegar-leave-active {
  transition: max-height 0.5s ease, opacity 0.5s ease;
}
.desplegar-enter,
.desplegar-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
